define("Tavanoteam.SeePriceInCartMerchZone.SeePriceInCartMerchZone", [
  "MerchZone.View"
], function (MerchZoneView) {
  "use strict";

  _.extend(MerchZoneView.prototype, {
    formattedItemExtendFunction: function (item, formattedItem) {
      formattedItem.price.formatted = !item.dontshowprice
        ? item.onlinecustomerprice_formatted
        : item.noPriceMessage
        ? item.noPriceMessage
        : "See Price in Cart";
      formattedItem.price.old = !item.dontshowprice
        ? formattedItem.price.old
        : "";
      return formattedItem;
    }
  });
});
